import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router";
import Navbar from "./components/Navbar";
import { AuthLayout } from "./components/PrivateRoute/PrivateRoute";
import { ROUTES } from "./config/routes";
import "./App.css";
import Collections from "./views/Collections";
import CollectionSiteView from "./views/CollectionSiteView";
import NotificationBar from "./components/NotificationBar";
import Collection from "./views/Collection";
import { useAuth0 } from "./providers/AuthProvider";
import { setUser } from "./stores/user";
import { parseAuth0User } from "./utils/parsers";
import { useAppDispatch } from "./stores/store";
import SpecimenGallery from "./views/Specimen/SpecimenGallery";
import SpecimenViewer from "./views/Specimen/Specimen";
import SettingsView from "./views/Settings";
import ReportView from "./views/ReportView";

const App: React.FC = () => {
  const { user, isLoading, isAuthenticated } = useAuth0();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isLoading) {
      if (user && isAuthenticated) {
        dispatch(setUser(parseAuth0User(user)));
      }
    }
  }, [user, isLoading, isAuthenticated, dispatch]);

  return (
    <Router>
      <>
        <NotificationBar />
        <div className="home">
          <div className="home-navbar">
            <Navbar />
          </div>
          <div className="home-content">
            <Routes>
              <Route element={<AuthLayout />}>
                <Route path={ROUTES.HOME} element={<Collections />} />
                <Route path={ROUTES.REPORTS} element={<ReportView />} />
                <Route path={ROUTES.COLLECTION} element={<Collection />} />
                <Route
                  path={ROUTES.SPECIMENGALLERY}
                  element={<SpecimenGallery />}
                />
                <Route path={ROUTES.SPECIMEN} element={<SpecimenViewer />} />
                <Route
                  path={ROUTES.COLLECTIONSSITES}
                  element={<CollectionSiteView />}
                />
                <Route path={ROUTES.SETTINGS} element={<SettingsView />} />
              </Route>
            </Routes>
          </div>
        </div>
      </>
    </Router>
  );
};

export default App;
